import Cookies from 'js-cookie';

const defaultAttributes = (): Cookies.CookieAttributes => ({
  path: '/',
  sameSite: 'lax',
  secure: window.location.protocol === 'https:'
});

export const setCookie = (
  name: string,
  value: string,
  options?: Cookies.CookieAttributes
): string | undefined => Cookies.set(name, value, { ...defaultAttributes(), ...options });

export const getCookie = (name: string): string | undefined => Cookies.get(name);

export const removeCookie = (name: string, options?: Cookies.CookieAttributes): void =>
  Cookies.remove(name, { path: '/', ...options });
